export default __webpack_public_path__ + "static/media/pass.a59bb3dd.png";